import EmailTemplate from './Steps/EmailTemplate'
import {StepperComponent} from '../../../../_metronic/assets/ts/components'
import {useIntl} from 'react-intl'
import {useEffect, useRef, useState} from 'react'
import {ICreateAccount, sendEmailAccountSchemas} from '../components/SendEmailAccountWizard'
import {Form, Formik, FormikValues} from 'formik'
import {toast} from 'react-toastify'
import {InvestorList} from './Steps/InvestorList'
import {PreviewTemplate} from './Steps/PreviewTemplate'
import {Button, Modal} from 'react-bootstrap'
import {ToolTipUI} from '../../widgets/components/UI/ToolTipUI'
import {useAuth} from '../../auth'
import {
  editEmailDraft,
  getSingleEmailByEmailId,
  saveEmailDraft,
  sendBukEmails,
  sendTestEmail,
} from '../core/_request'
import {useLocation, useNavigate} from 'react-router-dom'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'

const SendEmail = () => {
  const inits: ICreateAccount = {
    selectTemplate: '',
    senderEmail: '',
    subject: '',
    footer: false,
    quillText: '',
    personalizeEmail: false,
    selectedInvestorUserIds: [],
    selectedTypeInvestor: '',
    checkedAll: false,
    pitchDeckId: '',
    updateId: '',
    bccEmail: '',
    toExistingInvestors: false,
  }
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [, setCurrentSchema] = useState([{}])
  const {formatMessage} = useIntl()
  const [initValues] = useState<ICreateAccount>(inits)
  const [emailShow, setEmailShow] = useState(false)
  const [selectedTypeInvestor, setSelectedTypeInvestors] = useState('')
  const [checkedAll, setCheckedAll] = useState(false)
  const [investorUsers, setInvestorUsers] = useState<any>([])
  const [error, setError] = useState(false)
  const [quillText, setQuillText] = useState('')
  const [emailSignature, setEmailSignature] = useState('')

  const [showInvestorUsers, setShowInvestorUsers] = useState<any[]>([])
  const [recipientEmail, setRecipientEmail] = useState('')
  const [emailError, setEmailError] = useState('')

  const {companyId} = useAuth()
  const [stepperState, setStepperState] = useState(stepper)
  const [storeFileIds, setStoreFileIds] = useState<any>([])
  const {currentUser} = useAuth()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const [emailData, setEmailData] = useState<any>(undefined)
  const [footer, setFooter] = useState(false)
  const [templateData, setTemplateData] = useState<any>([])
  const [sendEmailLoading, setSendEmailLoading] = useState(false)
  const [sendTestEmailLoading, setSendTestEmailLoading] = useState(false)
  const [saveAsDraftLoading, setSaveAsDraftLoading] = useState(false)
  const [nextButtonDisable, setNextButtonDisable] = useState<any>(false)
  const [createdMailId, setCreatedMailId] = useState<any>()

  const navigate = useNavigate()
  // Get the value of a specific query parameter
  const draftEmailId = queryParams.get('emailId')
  const handleClose = () => {
    setEmailShow(false)
    setRecipientEmail('')
    setEmailError('')
  }

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
    setCurrentSchema([{...sendEmailAccountSchemas[0 + 1]}])
    if (stepper.current) {
      if (draftEmailId !== null && !!emailData) {
        if (emailData && emailData.email.status !== 'DRAFT') {
          stepper.current.goto(3)
        } else {
          stepper.current.goto(1)
        }
      } else {
        setError(false)
        stepper.current.getNextStepIndex() === 2 && selectedTypeInvestor
          ? setError(true)
          : setError(false)
      }
    }
  }

  const prevStep = () => {
    toast.dismiss()
    if (!stepper.current) {
      return
    }

    stepper.current.goPrev()
    setCurrentSchema([{...sendEmailAccountSchemas[stepper.current.currentStepIndex - 1]}])
  }

  const submitStep = (values: ICreateAccount, actions: FormikValues) => {
    if (!stepper.current) {
      return
    }
    setCurrentSchema([{...sendEmailAccountSchemas[stepper.current.currentStepIndex]}])

    if (stepper.current.currentStepIndex !== stepper.current.totatStepsNumber) {
      setError(false)
      stepper.current.goNext()
    } else {
      stepper.current.goto(1)
      actions.resetForm()
    }
  }

  useEffect(() => {
    if (!stepperRef.current) {
      return
    }
    loadStepper()
  }, [stepperRef]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!!emailData) {
      loadStepper()
    }
  }, [emailData]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!!draftEmailId) {
      getSingleEmailDetails(parseInt(draftEmailId))
    }
  }, [draftEmailId]) // eslint-disable-line react-hooks/exhaustive-deps

  const saveDraftSendEmail = async (formik: any) => {
    try {
      setSaveAsDraftLoading(true)
      if (companyId && formik.values.subject && formik.values.quillText) {
        let event: any = {
          subject: formik.values.subject,
          status: 'DRAFT',
          body: formik.values.quillText,
          companyId,
          createdBy: currentUser?.userId,
          pitchDeckId: +formik.values.pitchDeckId,
          updateId: +formik.values.updateId,
          bccEmail: formik.values?.bccEmail,
          toExistingInvestors: formik.values.selectedTypeInvestor === 'existing',
        }
        if (footer) {
          event = {...event, footer: emailSignature}
        } else {
          event = {...event, footer: ''}
        }
        if (addFiles.length > 0) {
          event = {...event, files: addFiles}
        }
        if (!!draftEmailId || createdMailId) {
          const {
            data: {success, errors},
          }: any = await editEmailDraft(parseInt(draftEmailId || createdMailId), event)
          if (success) {
            setSaveAsDraftLoading(false)
            toast.success(formatMessage({id: 'Draft updated successfully'}))
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.EditEmailDraftSuccessful,
                action: 'normal',
                metadata: {
                  user_id: currentUser?.userId,
                  email: currentUser?.email,
                  company_id: companyId,
                  draft_email_id: draftEmailId || createdMailId,
                  subject: formik.values.subject,
                  status: 'DRAFT',
                  created_by: currentUser?.userId,
                  pitch_deck_id: +formik.values.pitchDeckId,
                  update_id: +formik.values.updateId,
                  bcc_email: formik.values?.bccEmail,
                  to_existing_investors: formik.values.selectedTypeInvestor === 'existing',
                },
              },
            })
          } else {
            setSaveAsDraftLoading(false)
            errors.forEach((error: string) => {
              toast.error(formatMessage({id: error}))
            })
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.EditEmailDraftFailed,
                action: 'normal',
                metadata: {
                  user_id: currentUser?.userId,
                  email: currentUser?.email,
                  company_id: companyId,
                  draft_email_id: draftEmailId || createdMailId,
                  subject: formik.values.subject,
                  status: 'DRAFT',
                  created_by: currentUser?.userId,
                  pitch_deck_id: +formik.values.pitchDeckId,
                  error: errors[0],
                },
              },
            })
          }
        } else {
          const {
            data: {data, success, errors},
          }: any = await saveEmailDraft(event)

          if (success) {
            setCreatedMailId(data?.emailId)
            setSaveAsDraftLoading(false)
            toast.success(formatMessage({id: 'Data saved as Draft.'}))
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.SaveEmailDraftSuccessful,
                action: 'normal',
                metadata: {
                  user_id: currentUser?.userId,
                  email: currentUser?.email,
                  company_id: companyId,
                  Email_id: data?.emailId,
                  subject: formik.values.subject,
                  status: 'DRAFT',
                  created_by: currentUser?.userId,
                  pitch_deck_id: +formik.values.pitchDeckId,
                  update_id: +formik.values.updateId,
                  bcc_email: formik.values?.bccEmail,
                  to_existing_investors: formik.values.selectedTypeInvestor === 'existing',
                },
              },
            })
          } else {
            setSaveAsDraftLoading(false)
            errors.forEach((error: string) => {
              toast.error(formatMessage({id: error}))
            })
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.SaveEmailDraftFailed,
                action: 'normal',
                metadata: {
                  user_id: currentUser?.userId,
                  email: currentUser?.email,
                  company_id: companyId,
                  email_id: data?.emailId,
                  subject: formik.values.subject,
                  status: 'DRAFT',
                  created_by: currentUser?.userId,
                  pitch_deck_id: +formik.values.pitchDeckId,
                  error: errors[0],
                },
              },
            })
          }
        }
      }
    } catch (err) {
      setSaveAsDraftLoading(false)
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.SaveEmailDraftFailed,
          action: 'normal',
          metadata: {
            user_id: currentUser?.userId,
            email: currentUser?.email,
            company_id: companyId,
            subject: formik.values.subject,
            status: 'DRAFT',
            created_by: currentUser?.userId,
            pitch_deck_id: +formik.values.pitchDeckId,
            error: err,
          },
        },
      })
    } finally {
      setSaveAsDraftLoading(false)
    }
  }
  const sendEmailsInBulk = async (formik: any) => {
    try {
      setSendEmailLoading(true)
      if (companyId) {
        formik.values['body'] = formik.values.quillText
        formik.values.selectedInvestorUserIds = formik.values?.selectedInvestorUserIds?.filter(
          (item: any) => !!item.checked
        )
        const emailbody = {
          body: formik.values.body,
          footer: emailSignature ? emailSignature : '',
          selectedInvestorUserIds: formik.values.selectedInvestorUserIds,
          files: addFiles || formik.values.files,
          personalizeEmail: formik.values.personalizeEmail,
          pitchDeckId: +formik.values.pitchDeckId,
          updateId: +formik.values.updateId,
          bccEmail: formik.values?.bccEmail,
          toExistingInvestors: formik.values.selectedTypeInvestor === 'existing',
          subject: formik.values.subject,
          draftEmailId:
            parseInt(draftEmailId || '0') || parseInt(createdMailId || '0') || undefined,
        }
        const {
          data: {success, errors},
        }: any = await sendBukEmails(emailbody, companyId)

        if (success) {
          setSendEmailLoading(false)
          toast.success(formatMessage({id: 'Emails scheduled to be sent successfully'}))
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.SendBulkEmailsSuccessful,
              action: 'normal',
              metadata: {
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                selected_investor_user_ids: formik.values.selectedInvestorUserIds,
                personalize_email: formik.values.personalizeEmail,
                pitch_deck_id: +formik.values.pitchDeckId,
                update_id: +formik.values.updateId,
                bcc_email: formik.values?.bccEmail,
                to_existing_investors: formik.values.selectedTypeInvestor === 'existing',
                subject: formik.values.subject,
                draft_email_id:
                  parseInt(draftEmailId || '0') || parseInt(createdMailId || '0') || undefined,
              },
            },
          })
          navigate('/updates/send-emails')
        } else {
          setSendEmailLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.SendBulkEmailsFailed,
              action: 'normal',
              metadata: {
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                selected_investor_user_ids: formik.values.selectedInvestorUserIds,
                personalize_email: formik.values.personalizeEmail,
                pitch_deck_id: +formik.values.pitchDeckId,
                update_id: +formik.values.updateId,
                bcc_email: formik.values?.bccEmail,
                to_existing_investors: formik.values.selectedTypeInvestor === 'existing',
                subject: formik.values.subject,
                draft_email_id:
                  parseInt(draftEmailId || '0') || parseInt(createdMailId || '0') || undefined,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      setSendEmailLoading(false)
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.SendBulkEmailsFailed,
          action: 'normal',
          metadata: {
            user_id: currentUser?.userId,
            email: currentUser?.email,
            company_id: companyId,
            selected_investor_user_ids: formik.values.selectedInvestorUserIds,
            personalize_email: formik.values.personalizeEmail,
            pitch_deck_id: +formik.values.pitchDeckId,
            update_id: +formik.values.updateId,
            bcc_email: formik.values?.bccEmail,
            to_existing_investors: formik.values.selectedTypeInvestor === 'existing',
            subject: formik.values.subject,
            draft_email_id:
              parseInt(draftEmailId || '0') || parseInt(createdMailId || '0') || undefined,
            error: err,
          },
        },
      })
    }
  }
  const addFiles = storeFileIds?.map((file: any) => file.fileId)

  const sendtestEmail = async (formik: any) => {
    try {
      setSendTestEmailLoading(true)
      if (companyId) {
        formik.values['body'] = formik.values.quillText
        const emailbody = {
          body: formik.values.body,
          footer: emailSignature ? emailSignature : '',
          files: addFiles || formik.values.files,
          personalizeEmail: formik.values.personalizeEmail,
          pitchDeckId: +formik.values.pitchDeckId,
          updateId: +formik.values.updateId,
          subject: formik.values.subject,
          recipientEmail,
        }
        const {
          data: {success, errors},
        }: any = await sendTestEmail(emailbody, companyId)

        if (success) {
          setSendTestEmailLoading(false)
          toast.success(formatMessage({id: 'Sent test email'}))
          handleClose()
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.SendTestEmailSuccessful,
              action: 'normal',
              metadata: {
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                personalize_email: formik.values.personalizeEmail,
                pitch_deck_id: +formik.values.pitchDeckId,
                update_id: +formik.values.updateId,
                subject: formik.values.subject,
                recipient_email: recipientEmail,
              },
            },
          })
        } else {
          setSendTestEmailLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.SendTestEmailFailed,
              action: 'normal',
              metadata: {
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                personalize_email: formik.values.personalizeEmail,
                pitch_deck_id: +formik.values.pitchDeckId,
                update_id: +formik.values.updateId,
                subject: formik.values.subject,
                recipient_email: recipientEmail,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      setSendTestEmailLoading(false)
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.SendTestEmailFailed,
          action: 'normal',
          metadata: {
            user_id: currentUser?.userId,
            email: currentUser?.email,
            company_id: companyId,
            personalize_email: formik.values.personalizeEmail,
            pitch_deck_id: +formik.values.pitchDeckId,
            update_id: +formik.values.updateId,
            subject: formik.values.subject,
            recipient_email: recipientEmail,
            error: err,
          },
        },
      })
    }
  }
  const isValidEmail = (email: string) => {
    return /\S+@\S+\.\S+/.test(email)
  }
  const handleEmailChange = (event: any) => {
    if (!isValidEmail(event.target.value)) {
      setEmailError(formatMessage({id: 'Email is invalid'}))
    } else {
      setEmailError('')
    }

    setRecipientEmail(event.target.value)
  }
  const getSingleEmailDetails = async (draftEmailId: number) => {
    try {
      if (companyId) {
        const {
          data: {data: emaildata, success},
        }: any = await getSingleEmailByEmailId(draftEmailId)

        if (success) {
          if (!!emaildata.email.footer) {
            setFooter(true)
            setEmailSignature(emaildata.email.footer)
          } else {
            setFooter(false)
          }
          if (!!emaildata?.email.emailFiles) {
            setStoreFileIds(emaildata.email.emailFiles)
          }
          setEmailData(emaildata)
          let investorAssign: any = []
          if (!!emaildata.findInvestorUser.length) {
            emaildata.findInvestorUser.map((item: any) => {
              item['checked'] = true
              investorAssign.push(item)
              return item
            })
            setInvestorUsers([...investorAssign])
          }
        }
      }
    } catch (err) {
      console.log(err)
    }
  }
  return (
    <>
      <div
        ref={stepperRef}
        className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid mx-5 font-size-13'
        id='kt_create_account_stepper'
      >
        <div className='card  w-100 p-4 rounded-0'>
          <div className='d-flex flex-row gap-md-20 gap-10 w-100 px-5 mt-5'>
            <div className='stepper-item current' data-kt-stepper-element='nav'>
              <div className='stepper-wrapper d-flex flex-md-row flex-column'>
                <div className='stepper-icon w-40px h-40px ms-md-0 ms-n8'>
                  <i className='stepper-check fas fa-check'></i>
                  <span className='stepper-number'>{formatMessage({id: '1'})}</span>
                </div>
                <div className='stepper-label mt-md-0 mt-2 ms-md-n3 ms-2 text-align-start'>
                  <h3 className='stepper-title font-size-13'>{formatMessage({id: 'Step 1'})}</h3>

                  <div className='stepper-desc fw-semibold font-size-12'>
                    {formatMessage({id: 'Compose Email'})}
                  </div>
                </div>
              </div>
              <div className='stepper-line h-40px'></div>
            </div>

            <div className='stepper-item' data-kt-stepper-element='nav'>
              <div className='stepper-wrapper d-flex flex-md-row flex-column'>
                <div className='stepper-icon w-40px h-40px ms-md-0 ms-n10'>
                  <i className='stepper-check fas fa-check'></i>
                  <span className='stepper-number'>{formatMessage({id: '2'})}</span>
                </div>
                <div className='stepper-label mt-md-0 mt-2 ms-md-n3 ms-2'>
                  <h3 className='font-size-13 stepper-title'>{formatMessage({id: 'Step 2'})}</h3>
                  <div className='stepper-desc fw-semibold font-size-12'>
                    {formatMessage({id: 'Whom to send'})}
                  </div>
                </div>
              </div>
              <div className='stepper-line h-40px'></div>
            </div>

            <div className='stepper-item' data-kt-stepper-element='nav'>
              <div className='stepper-wrapper d-flex flex-md-row flex-column'>
                <div className='stepper-icon w-40px h-40px ms-md-0 ms-n5'>
                  <i className='stepper-check fas fa-check'></i>
                  <span className='stepper-number'>{formatMessage({id: '3'})}</span>
                </div>
                <div className='stepper-label mt-md-0 mt-2 ms-md-n3 ms-2'>
                  <h3 className='font-size-13 stepper-title'>{formatMessage({id: 'Step 3'})}</h3>
                  <div className='stepper-desc fw-semibold font-size-12'>
                    {formatMessage({id: 'Preview'})}
                  </div>
                </div>
              </div>
              <div className='stepper-line h-40px'></div>
            </div>
          </div>
          <div className='d-flex flex-row-fluid bg-body rounded'>
            <Formik
              validationSchema={
                stepper.current?.currentStepIndex === 1
                  ? sendEmailAccountSchemas[0]
                  : stepper.current?.currentStepIndex === 2
                  ? sendEmailAccountSchemas[1]
                  : ''
              }
              initialValues={initValues}
              onSubmit={submitStep}
            >
              {(formik) => (
                <Form className='py-2 w-100 px-3' noValidate id='kt_create_account_form'>
                  <div className='current' data-kt-stepper-element='content'>
                    <EmailTemplate
                      formik={formik}
                      setQuillText={setQuillText}
                      quillText={quillText}
                      emailSignature={emailSignature}
                      setEmailSignature={setEmailSignature}
                      storeFileIds={storeFileIds}
                      setStoreFileIds={setStoreFileIds}
                      setFooter={setFooter}
                      footer={footer}
                      setTemplateData={setTemplateData}
                      templateData={templateData}
                      emailData={emailData}
                    />
                  </div>

                  <div data-kt-stepper-element='content'>
                    <InvestorList
                      formik={formik}
                      checkedAll={checkedAll}
                      setCheckedAll={setCheckedAll}
                      investorUsers={investorUsers}
                      setInvestorUsers={setInvestorUsers}
                      setSelectedTypeInvestors={setSelectedTypeInvestors}
                      setNextButtonDisable={setNextButtonDisable}
                      nextButtonDisable={nextButtonDisable}
                    />
                  </div>

                  <div data-kt-stepper-element='content'>
                    <PreviewTemplate
                      investorUsers={
                        !!formik.values.selectedInvestorUserIds.length
                          ? formik.values.selectedInvestorUserIds
                          : investorUsers
                      }
                      formik={formik}
                      setInvestorUsers={setInvestorUsers}
                      showInvestorUsers={showInvestorUsers}
                      setShowInvestorUsers={setShowInvestorUsers}
                      stepperState={stepperState}
                      setStepperState={setStepperState}
                      storeFileIds={storeFileIds}
                      paramValue={draftEmailId}
                      emailData={emailData}
                      templateData={templateData}
                      stepper={stepper}
                      setCurrentSchema={setCurrentSchema}
                      emailSignature={emailSignature}
                      footer={footer}
                    />
                  </div>
                  {(!draftEmailId || (emailData && emailData.email.status === 'DRAFT')) && (
                    <div className='d-flex flex-stack pt-10'>
                      <div className='d-flex gap-6 justify-content-end w-100'>
                        <button
                          type='button'
                          className='btn btn-lg btn-light me-3 w-md-auto w-50 border font-size-13'
                          data-kt-stepper-action='previous'
                          onClick={prevStep}
                        >
                          {formatMessage({id: 'Back'})}
                        </button>
                        {stepper.current?.currentStepIndex ===
                          stepper.current?.totatStepsNumber! && (
                          <button
                            type='button'
                            className='btn btn-lg btn-light me-3 w-md-auto w-50 border font-size-13'
                            onClick={() => setEmailShow(true)}
                          >
                            {formatMessage({id: 'Send Test email'})}
                          </button>
                        )}
                        {stepper.current?.currentStepIndex ===
                          stepper.current?.totatStepsNumber! && (
                          <button
                            disabled={
                              sendEmailLoading || formik.values.selectedInvestorUserIds.length === 0
                            }
                            type='button'
                            className='btn btn-lg btn-primary me-3 w-md-auto w-50 border font-size-13'
                            onClick={() => sendEmailsInBulk(formik)}
                          >
                            {!sendEmailLoading && (
                              <span className='indicator-label font-size-13 p-0'>
                                {formatMessage({id: 'Send  email'})}
                              </span>
                            )}
                            {sendEmailLoading && (
                              <span className='indicator-label font-size-13 p-0'>
                                {formatMessage({id: 'Please wait...'})}
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                              </span>
                            )}
                          </button>
                        )}
                        {stepper.current?.currentStepIndex === 1 && (
                          <button
                            disabled={!formik.isValid || saveAsDraftLoading}
                            className='btn btn-lg btn-primary w-md-auto w-50 font-size-13'
                            onClick={() => saveDraftSendEmail(formik)}
                            type='submit'
                          >
                            {!saveAsDraftLoading && (
                              <span className='indicator-label font-size-13 p-0'>
                                {formatMessage({id: 'Save as draft'})}
                              </span>
                            )}
                            {saveAsDraftLoading && (
                              <span className='indicator-label font-size-13 p-0'>
                                {formatMessage({id: 'Please wait...'})}
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                              </span>
                            )}
                          </button>
                        )}
                        {stepper.current?.currentStepIndex !==
                          stepper.current?.totatStepsNumber! && (
                          <>
                            {stepper.current?.currentStepIndex === 2 ? (
                              <button
                                type='submit'
                                disabled={error || nextButtonDisable}
                                className={`btn btn-lg btn-primary me-3 w-md-auto w-50 border font-size-13`}
                              >
                                <span className='indicator-label'>
                                  {stepper.current?.currentStepIndex !==
                                    stepper.current?.totatStepsNumber! &&
                                    formatMessage({id: 'Next step'})}
                                </span>
                              </button>
                            ) : (
                              <button
                                type='submit'
                                disabled={error}
                                className={`btn btn-lg btn-primary me-3 w-md-auto w-50 border font-size-13 `}
                              >
                                <span className='indicator-label'>
                                  {stepper.current?.currentStepIndex !==
                                    stepper.current?.totatStepsNumber! &&
                                    formatMessage({id: 'Next step'})}
                                </span>
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  )}
                  <Modal show={emailShow} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title>{formatMessage({id: 'Send Test Email'})}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <label>{formatMessage({id: 'Recipient Email'})}</label>
                      <ToolTipUI></ToolTipUI>

                      <div className='input-group'>
                        <input
                          type='email'
                          className='form-control'
                          name='setRecipientEmail'
                          id='email'
                          value={recipientEmail}
                          placeholder={formatMessage({id: 'Email'})}
                          onChange={handleEmailChange}
                        />
                      </div>
                      {emailError && (
                        <p className='text-danger'>{formatMessage({id: emailError})}</p>
                      )}
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant='light' onClick={handleClose}>
                        {formatMessage({id: 'Close'})}
                      </Button>
                      <Button
                        disabled={sendTestEmailLoading}
                        type='button'
                        variant='primary'
                        onClick={(e) => sendtestEmail(formik)}
                      >
                        {!sendTestEmailLoading && (
                          <span className='indicator-label font-size-13 p-0'>
                            {formatMessage({id: 'Send Test Email'})}
                          </span>
                        )}
                        {sendTestEmailLoading && (
                          <span className='indicator-label font-size-13 p-0'>
                            {formatMessage({id: 'Please wait...'})}
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        )}
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  )
}

export default SendEmail
